import axios from "axios";

// const baseURL = "https://havaianas-confi.mbsi.com.ph";
// const baseURL = "https://evaair.mbsi.com.ph";
// const baseURL = "https://attila.mbsi.com.ph";
// const baseURL = "https://haskoning.mbsi.com.ph";
// const baseURL = "https://autodesk.mbsi.com.ph";
// const baseURL = "https://odfjell.mbsi.com.ph";
// const baseURL = "https://quadrant.mbsi.com.ph";
// const baseURL = "https://dev-test.mbsi.com.ph";
// const baseURL = "https://nhk.mbsi.com.ph"; 
const baseURL = "https://terrysa.mbsi.com.ph"; 
// const baseURL = "https://nhk.mbsi.com.ph"; 
// const baseURL = "https://nhk.mbsi.com.ph"; 
// const baseURL = "https://nhk.mbsi.com.ph"; 
export default axios.create({
  baseURL: baseURL,
  // You can add your headers here
});
